import { css } from "styled-components";

// On a phone a search form stands each field and each Button on its own row across its
// width, the Buttons last, inside 16px corners and 16px of padding (PHONE-R39, PHONE-R40).
const phoneFormRadius = 16;
const phoneFormPadding = 16;

export const phoneSearchFormLayout = css`
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  padding: ${phoneFormPadding}px;
  border-radius: ${phoneFormRadius}px;

  /* Doubled to outrank a field slot's own desktop width. */
  && > * {
    width: auto;
  }
`;
